import { Api } from "@relode/core";
import { TotalCountResponse } from "@relode/core/backend/responses";

import { JobTotalCountResponse, CandidateInterviewResponse } from ".";

export const teamMemberDashboardService = {
    getJobCountsForHiringTeamMember: async () => {
        const url = "/dashboard/hiring-team-member/jobs/total";

        const result = await Api.url(url)
            .throwOnAbort()
            .retries(3)
            .useSignal()
            .track({ name: "memberDashboardService.getOpenJobs" })
            .get<JobTotalCountResponse>();

        return result;
    },

    getSubmittedCandidates: async () => {
        const url = "/dashboard/hiring-team-member/candidates/submitted/total";

        const result = await Api.url(url)
            .throwOnAbort()
            .retries(3)
            .useSignal()
            .track({ name: "memberDashboardService.getSubmittedCandidates" })
            .get<TotalCountResponse>();

        return result;
    },

    getInterviewingPastCandidates: async () => {
        const url =
            "/dashboard/hiring-team-member/candidates/interviewing/past";

        const result = await Api.url(url)
            .throwOnAbort()
            .retries(3)
            .useSignal()
            .track({
                name: "memberDashboardService.getInterviewingPastCandidates",
            })
            .get<TotalCountResponse>();

        return result;
    },

    getInterviewingPastAwaitingFeedbackCandidates: async () => {
        const url =
            "/dashboard/hiring-team-member/candidates/interviewing/past/awaiting-feedback";

        const result = await Api.url(url)
            .throwOnAbort()
            .retries(3)
            .useSignal()
            .track({
                name:
                    "memberDashboardService.getInterviewingPastAwaitingFeedbackCandidates",
            })
            .get<TotalCountResponse>();

        return result;
    },

    getUpcomingInterviews: async () => {
        const url =
            "/dashboard/hiring-team-member/candidates/interviewing/upcoming";

        const result = await Api.url(url)
            .throwOnAbort()
            .retries(3)
            .useSignal()
            .track({ name: "memberDashboardService.getUpcomingInterviews" })
            .get<CandidateInterviewResponse[]>();

        return result;
    },
};
